import React from "react";
import { Link } from "react-router-dom";
import { dashboardAsset } from "../../utils/dashboardAssets";
import { GATEWAY_ECOSYSTEM } from "../../data/dashboardMockData";

const EcosystemModules = () => {
  const chronicle = GATEWAY_ECOSYSTEM.chronicle;
  const vr = GATEWAY_ECOSYSTEM.vr;
  const game = GATEWAY_ECOSYSTEM.game;
  const library = GATEWAY_ECOSYSTEM.library;

  return (
    <section className="dg-eco">
      <div className="dg-eco-grid">
        <article className={`dg-eco-card dg-gold-ring dg-premium-ring dg-eco-card--memory dg-eco-card--thumb-${chronicle.thumbGlow}`}>
          <div className={`dg-eco-card__thumb dg-eco-thumb-glow dg-eco-thumb-glow--${chronicle.thumbGlow}`}>
            <img className="dg-eco-thumb-img dg-eco-thumb-img--chronicle" src={dashboardAsset(chronicle.img)} alt="" loading="lazy" />
            <div className="dg-eco-card__thumb-scrim" aria-hidden />
            <div className="dg-eco-card__thumb-core dg-eco-card__thumb-core--memory" aria-hidden />
          </div>
          <div className="dg-eco-card__body">
            <div className="dg-eco-card__titlebar dg-eco-card__titlebar--strong">
              <h3 className="dg-eco-card__title serif">{chronicle.title}</h3>
            </div>
            {chronicle.copy.map((line) => (
              <p key={line} className="dg-eco-copy dg-eco-copy--chronicle">
                {line}
              </p>
            ))}
            <div className="dg-eco-access">
              <span className={`dg-eco-dot dg-eco-dot--${chronicle.accessTone}`} aria-hidden />
              <span className="dg-eco-access__label">{chronicle.accessLabel}</span>
            </div>
            <div className="dg-eco-card__push" aria-hidden />
            <Link
              to="/chronicles"
              className="dg-btn dg-btn--blue-outline dg-btn--compact dg-btn--game dg-btn--chronicle dg-btn--sweep"
            >
              {chronicle.button} <i className="fas fa-arrow-right dg-btn__icon" aria-hidden />
            </Link>
            <footer className="dg-eco-foot dg-label-up">{chronicle.footer}</footer>
          </div>
        </article>

        <article className={`dg-eco-card dg-gold-ring dg-premium-ring dg-premium-ring--interactive dg-eco-card--thumb-${vr.thumbGlow}`}>
          <div className={`dg-eco-card__thumb dg-eco-thumb-glow dg-eco-thumb-glow--${vr.thumbGlow}`}>
            <img className="dg-eco-thumb-img dg-eco-thumb-img--vr" src={dashboardAsset(vr.img)} alt="" loading="lazy" />
            <div className="dg-eco-card__thumb-scrim" aria-hidden />
          </div>
          <div className="dg-eco-card__body">
            <div className="dg-eco-card__titlebar dg-eco-card__titlebar--strong">
              <h3 className="dg-eco-card__title serif">{vr.title}</h3>
            </div>
            <p className="dg-eco-copy">{vr.copyLine}</p>
            <div className="dg-eco-row dg-eco-row--status">
              <span className="dg-eco-dot dg-eco-dot--muted" aria-hidden />
              <span className="dg-pill dg-pill--muted">Coming Soon</span>
            </div>
            <div className="dg-eco-card__push" aria-hidden />
            <Link
              to="/world/oshar"
              className="dg-btn dg-btn--primary dg-btn--compact dg-btn--game dg-btn--sweep"
            >
              Explore Oshar World <i className="fas fa-arrow-right dg-btn__icon" aria-hidden />
            </Link>
            <div className="dg-eco-access dg-eco-access--inline">
              <span className="dg-eco-dot dg-eco-dot--muted" aria-hidden />
              <span className="dg-eco-access__label">Immersive client not installed from this panel</span>
            </div>
          </div>
        </article>

        <article className={`dg-eco-card dg-gold-ring dg-premium-ring dg-premium-ring--interactive dg-eco-card--thumb-${game.thumbGlow}`}>
          <div className={`dg-eco-card__thumb dg-eco-thumb-glow dg-eco-thumb-glow--${game.thumbGlow}`}>
            <img className="dg-eco-thumb-img dg-eco-thumb-img--game" src={dashboardAsset(game.img)} alt="" loading="lazy" />
            <div className="dg-eco-card__thumb-scrim" aria-hidden />
          </div>
          <div className="dg-eco-card__body">
            <div className="dg-eco-card__titlebar dg-eco-card__titlebar--strong">
              <h3 className="dg-eco-card__title serif">{game.title}</h3>
            </div>
            <p className="dg-eco-copy">{game.copyLine}</p>
            <div className="dg-eco-row dg-eco-row--status">
              <span className="dg-eco-dot dg-eco-dot--muted" aria-hidden />
              <span className="dg-pill dg-pill--muted">Coming Soon</span>
            </div>
            <div className="dg-eco-card__push" aria-hidden />
            <Link
              to="/library"
              className="dg-btn dg-btn--gold-outline dg-btn--compact dg-btn--game dg-btn--sweep"
            >
              Browse Experiences <i className="fas fa-arrow-right dg-btn__icon" aria-hidden />
            </Link>
            <div className="dg-eco-access dg-eco-access--inline">
              <span className="dg-eco-dot dg-eco-dot--muted" aria-hidden />
              <span className="dg-eco-access__label">Standalone game client — preview only</span>
            </div>
          </div>
        </article>

        <article className={`dg-eco-card dg-gold-ring dg-premium-ring dg-premium-ring--interactive dg-eco-card--thumb-${library.thumbGlow}`}>
          <div className={`dg-eco-card__thumb dg-eco-thumb-glow dg-eco-thumb-glow--${library.thumbGlow}`}>
            <img className="dg-eco-thumb-img dg-eco-thumb-img--library" src={dashboardAsset(library.img)} alt="" loading="lazy" />
            <div className="dg-eco-card__thumb-scrim" aria-hidden />
          </div>
          <div className="dg-eco-card__body">
            <div className="dg-eco-card__titlebar dg-eco-card__titlebar--strong">
              <h3 className="dg-eco-card__title serif">{library.title}</h3>
            </div>
            <div className="dg-eco-row dg-eco-row--status">
              <span className="dg-eco-dot dg-eco-dot--vault" aria-hidden />
              <span className="dg-pill dg-pill--muted">Public catalog</span>
            </div>
            <div className="dg-eco-card__push" aria-hidden />
            <Link
              to="/library"
              className="dg-btn dg-btn--ghost dg-btn--compact dg-btn--wide dg-btn--game dg-btn--sweep"
            >
              {library.button} <i className="fas fa-arrow-right dg-btn__icon" aria-hidden />
            </Link>
            <footer className="dg-eco-foot dg-label-up">{library.footer}</footer>
            <div className="dg-eco-access dg-eco-access--inline">
              <span className={`dg-eco-dot dg-eco-dot--${library.accessTone}`} aria-hidden />
              <span className="dg-eco-access__label">{library.accessLabel}</span>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default EcosystemModules;
